/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: aspera-file-select-service.ts
 */

// This service is an implementation for FileSelectService.
// Components should invoke the abstract FileSelectService, not this specific implementation.

angular.module('prism-ui.components').service('AsperaFileSelectService', function (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    AsperaConnectService: JS5Object,
    FileSelectService: JS5Object,
    ModalService: JS5Object,
) {

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.initialize = (fileSelectConfig: JS5Object) => {
        // Nothing to initialize
    };

    const unregisterCurrentAsperaFiles = (fileSelectConfig: JS5Object) => {
        _.forEach(fileSelectConfig.currentAsperaFileObjects, (asperaFileObject: JS5Object) => {
            AsperaConnectService.unregisterFile(asperaFileObject);
        });
        fileSelectConfig.currentAsperaFileObjects = null;
    };

    this.onFileChanged = (fileSelectConfig: JS5Object, newFileValue: JS5Object) => {
        if (_.get(newFileValue, 'type') !== 'ASPERA') {
            unregisterCurrentAsperaFiles(fileSelectConfig);
        }
    };

    this.cleanup = (fileSelectConfig: JS5Object) => {
        unregisterCurrentAsperaFiles(fileSelectConfig);
    };


    //========================//
    // Aspera File Validation //
    //========================//

    this.promptFile = (fileSelectConfig: JS5Object, asperaFileObjects: JS5Object[]) => {
        unregisterCurrentAsperaFiles(fileSelectConfig);
        if (!fileSelectConfig.isMultiSelect) {
            asperaFileObjects = asperaFileObjects.slice(0, 1);
        }

        FileSelectService.startValidation(
            fileSelectConfig,
            'ASPERA',
            asperaFileObjects
        );

        let validationPromises = asperaFileObjects.map((asperaFileObject: JS5Object) => {
            return fileSelectConfig.validateAsperaFile({
                asperaFileObject: asperaFileObject,
            });
        });
        return FileSelectService.waitForValidation(
            fileSelectConfig, $q.all(validationPromises), (validationResults: JS5Object[]) => {
                onValidationResolved(fileSelectConfig, asperaFileObjects, validationResults);
            }, (rejectedValue: any) => {
                onValidationFailed(fileSelectConfig, asperaFileObjects, rejectedValue);
            }
        );
    };

    const onValidationResolved = (
        fileSelectConfig: JS5Object,
        asperaFileObjects: JS5Object[],
        validationResults: JS5Object[]
    ) => {
        let hasErrors = false;
        let hasWarnings = false;
        let flattenedResults = _.flatten(validationResults);
        _.forEach(flattenedResults, (validationResult: JS5Object) => {
            hasErrors = hasErrors || !_.isEmpty(validationResult.errors);
            hasWarnings = hasWarnings || !_.isEmpty(validationResult.warnings);
        });
        if (hasErrors || hasWarnings) {
            onValidationFailed(fileSelectConfig, asperaFileObjects, validationResults);
            if (fileSelectConfig.canShowValidationErrorModal()) {
                ModalService.showAssetValidationResultsModal(
                    flattenedResults, !hasErrors, () => {
                        onValidationCompleted(fileSelectConfig, asperaFileObjects, validationResults);
                    });
            }
        } else {
            onValidationCompleted(fileSelectConfig, asperaFileObjects, validationResults);
        }
    };

    const onValidationCompleted = (
        fileSelectConfig: JS5Object,
        asperaFileObjects: JS5Object[],
        validationResults: JS5Object[]
    ) => {
        fileSelectConfig.currentAsperaFileObjects = _.clone(asperaFileObjects);
        _.forEach(asperaFileObjects, (asperaFileObject: JS5Object) => {
            AsperaConnectService.registerFileForUpload(asperaFileObject);
        });
        FileSelectService.completeValidation(
            fileSelectConfig,
            'ASPERA',
            asperaFileObjects,
            validationResults
        );
    };

    const onValidationFailed = (
        fileSelectConfig: JS5Object,
        asperaFileObjects: JS5Object[],
        results: any
    ) => {
        FileSelectService.failValidation(
            fileSelectConfig,
            'ASPERA',
            asperaFileObjects,
            results
        );
    };
});


//=================//
// Lifecycle Hooks //
//=================//

// Load this service when app is initialized
angular.module('prism-ui.components').run((
    FileSelectService: JS5Object,
    AsperaFileSelectService: JS5Object,
) => {
    FileSelectService.registerFileSelectServiceImplementation('ASPERA', AsperaFileSelectService);
});
